(function () {
  function swiperInit(section) {
    if (!section) return;
    syncProductMediaLayout(section);
    subSliderInit(section);
    sliderInit(section);
    popupSliderInit(section);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit(e.target);
  });

  swiperInit(document.currentScript?.parentElement);

  window.matchMedia("(min-width: 990px)").addEventListener("change", () => {
    document.querySelectorAll(".product-section").forEach((section) => {
      syncProductMediaLayout(section);
    });
  });
})();
